import React from "react";
import styles from "./buttonGroup.module.scss";
import cn from "classnames";

export const ButtonGroup: React.FC<{
  children: React.ReactNode;
  className?: string;
  slot?: string;
}> = ({ children, className, slot }) => {
  return (
    <div slot={slot} className={cn(className, styles.buttonGroup)}>
      {children}
    </div>
  );
};
